import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_plugin_04961342 from 'nuxt_plugin_plugin_04961342'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_068201ef from 'nuxt_plugin_plugin_068201ef'; // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_22a634dd from 'nuxt_plugin_appplugin_22a634dd'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_d86a3cdc from 'nuxt_plugin_configplugin_d86a3cdc'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_4ce16825 from 'nuxt_plugin_nitrobridgeserver_4ce16825'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_0926aea6 from 'nuxt_plugin_nitrobridgeclient_0926aea6'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_nuxtvuexroutersync_640336dd from 'nuxt_plugin_nuxtvuexroutersync_640336dd'; // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_axios_28c677f5 from 'nuxt_plugin_axios_28c677f5'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_da4e785e from 'nuxt_plugin_workbox_da4e785e'; // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_289da9e4 from 'nuxt_plugin_metaplugin_289da9e4'; // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_capiplugin_36942bfe from 'nuxt_plugin_capiplugin_36942bfe'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_33bc726b from 'nuxt_plugin_errorpluginserver_33bc726b'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_vuetify_fc348dfc from 'nuxt_plugin_vuetify_fc348dfc'; // Source: ../plugins/vuetify.js (mode: 'all')
import nuxt_plugin_global_023465fb from 'nuxt_plugin_global_023465fb'; // Source: ../plugins/global.js (mode: 'all')
import nuxt_plugin_mixins_2cefdb2c from 'nuxt_plugin_mixins_2cefdb2c'; // Source: ../plugins/mixins.js (mode: 'all')
import nuxt_plugin_constants_1d32cb3e from 'nuxt_plugin_constants_1d32cb3e'; // Source: ../plugins/constants.js (mode: 'all')
import nuxt_plugin_datafilter_3a10e6f5 from 'nuxt_plugin_datafilter_3a10e6f5'; // Source: ../plugins/data-filter.js (mode: 'all')
import nuxt_plugin_configdata_58e5874a from 'nuxt_plugin_configdata_58e5874a'; // Source: ../plugins/config-data.js (mode: 'all')
import nuxt_plugin_axiosinterceptor_03752b02 from 'nuxt_plugin_axiosinterceptor_03752b02'; // Source: ../plugins/axios-interceptor.js (mode: 'all')
import nuxt_plugin_persistedStateclient_1eb8f1d5 from 'nuxt_plugin_persistedStateclient_1eb8f1d5'; // Source: ../plugins/persistedState.client.js (mode: 'client')
import nuxt_plugin_pwaupdate_99bdde7c from 'nuxt_plugin_pwaupdate_99bdde7c'; // Source: ../plugins/pwa-update.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "titleTemplate": "%s - foaps",
              "title": "foaps",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1"
              }, {
                "hid": "description",
                "name": "description",
                "content": ""
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicon.ico"
              }, {
                "rel": "stylesheet",
                "href": "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap"
              }, {
                "rel": "stylesheet",
                "type": "text/css",
                "href": "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&display=swap"
              }, {
                "rel": "stylesheet",
                "type": "text/css",
                "href": "https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"
              }],
              "script": [{
                "src": "/libs/js/rsvp-3.1.0.min.js"
              }, {
                "src": "/libs/js/sha-256.min.js"
              }, {
                "src": "/libs/js/qz-tray.js"
              }, {
                "src": "/libs/js/jsrsasign-all-min.js"
              }],
              "style": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 13;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 13:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_plugin_04961342 === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_plugin_04961342(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_plugin_068201ef === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_plugin_068201ef(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_appplugin_22a634dd === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_appplugin_22a634dd(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_configplugin_d86a3cdc === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_configplugin_d86a3cdc(app.context, inject);
        case 28:
          if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_4ce16825 === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_nitrobridgeserver_4ce16825(app.context, inject);
        case 31:
          if (!(process.client && typeof nuxt_plugin_nitrobridgeclient_0926aea6 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_nitrobridgeclient_0926aea6(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_nuxtvuexroutersync_640336dd === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_nuxtvuexroutersync_640336dd(app.context, inject);
        case 37:
          if (!(typeof nuxt_plugin_axios_28c677f5 === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_axios_28c677f5(app.context, inject);
        case 40:
          if (!(process.client && typeof nuxt_plugin_workbox_da4e785e === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_workbox_da4e785e(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_metaplugin_289da9e4 === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_metaplugin_289da9e4(app.context, inject);
        case 46:
          if (!(typeof nuxt_plugin_capiplugin_36942bfe === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_capiplugin_36942bfe(app.context, inject);
        case 49:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_33bc726b === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_errorpluginserver_33bc726b(app.context, inject);
        case 52:
          if (!(typeof nuxt_plugin_vuetify_fc348dfc === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_vuetify_fc348dfc(app.context, inject);
        case 55:
          if (!(typeof nuxt_plugin_global_023465fb === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_global_023465fb(app.context, inject);
        case 58:
          if (!(typeof nuxt_plugin_mixins_2cefdb2c === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_mixins_2cefdb2c(app.context, inject);
        case 61:
          if (!(typeof nuxt_plugin_constants_1d32cb3e === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_constants_1d32cb3e(app.context, inject);
        case 64:
          if (!(typeof nuxt_plugin_datafilter_3a10e6f5 === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_datafilter_3a10e6f5(app.context, inject);
        case 67:
          if (!(typeof nuxt_plugin_configdata_58e5874a === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_configdata_58e5874a(app.context, inject);
        case 70:
          if (!(typeof nuxt_plugin_axiosinterceptor_03752b02 === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_axiosinterceptor_03752b02(app.context, inject);
        case 73:
          if (!(process.client && typeof nuxt_plugin_persistedStateclient_1eb8f1d5 === 'function')) {
            _context2.next = 76;
            break;
          }
          _context2.next = 76;
          return nuxt_plugin_persistedStateclient_1eb8f1d5(app.context, inject);
        case 76:
          if (!(process.client && typeof nuxt_plugin_pwaupdate_99bdde7c === 'function')) {
            _context2.next = 79;
            break;
          }
          _context2.next = 79;
          return nuxt_plugin_pwaupdate_99bdde7c(app.context, inject);
        case 79:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 82;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 82:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 83:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };